import { createReducer } from 'utils/redux'

const receiveIdentityMapHandler = ({ action, draft }) => {
  return action.payload
}

const actions = {
  RECEIVE_IDENTITY_MAP: receiveIdentityMapHandler
}

const identityReducer = createReducer({}, actions)

export default identityReducer